import script from "./Install.vue?vue&type=script&setup=true&lang=js"
export * from "./Install.vue?vue&type=script&setup=true&lang=js"

import "./Install.vue?vue&type=style&index=0&id=ee26bd5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee26bd5e"]])

export default __exports__